import StorageService from '@/utils/storage-service';
import StoreModuleService from '../StoreModuleService';
import {
	initialState,
	DID_SEE_UTM_INTRO,
	IS_SIDEBAR_COLLAPSED_KEY,
	IS_PROJECT_MENU_PINNED_KEY,
	SEEN_INTERFACE_EXPLANATION,
	DISMISSED_SPACE_TAB_EXPLANATION,
	DISMISSED_PLACEMENT_TAB_EXPLANATION,
} from './state';

const storage = StorageService.getStorage();

export const SET_DID_SEE_UTM_INTRO = 'SET_DID_SEE_UTM_INTRO';
export const SET_IS_SIDEBAR_COLLAPSED = 'SET_IS_SIDEBAR_COLLAPSED';
export const SET_IS_PROJECT_MENU_PINNED = 'SET_IS_PROJECT_MENU_PINNED';
export const SET_SHOW_INSPIRATION_CENTER = 'SET_SHOW_INSPIRATION_CENTER';
export const SET_SEEN_INTERFACE_EXPLANATION = 'SET_SEEN_INTERFACE_EXPLANATION';
export const SET_DISMISSED_SPACE_TAB_EXPLANATION = 'SET_DISMISSED_SPACE_TAB_EXPLANATION';
export const SET_DISMISSED_PLACEMENT_TAB_EXPLANATION = 'SET_DISMISSED_PLACEMENT_TAB_EXPLANATION';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_SHOW_INSPIRATION_CENTER](state, showInspirationCenter) {
		state.showInspirationCenter = showInspirationCenter;
	},
	[SET_IS_SIDEBAR_COLLAPSED](state, isSidebarCollapsed) {
		storage.setItem(IS_SIDEBAR_COLLAPSED_KEY, isSidebarCollapsed);
		state.isSidebarCollapsed = isSidebarCollapsed;
	},
	[SET_DID_SEE_UTM_INTRO](state, didSeeUtmIntro) {
		storage.setItem(DID_SEE_UTM_INTRO, didSeeUtmIntro);
		state.didSeeUtmIntro = didSeeUtmIntro;
	},
	[SET_IS_PROJECT_MENU_PINNED](state, isProjectMenuPinned) {
		storage.setItem(IS_PROJECT_MENU_PINNED_KEY, isProjectMenuPinned);
		state.isProjectMenuPinned = isProjectMenuPinned;
	},
	[SET_DISMISSED_SPACE_TAB_EXPLANATION](state, dismissedSpaceTabExplanation) {
		storage.setItem(DISMISSED_SPACE_TAB_EXPLANATION, dismissedSpaceTabExplanation);
		state.dismissedSpaceTabExplanation = dismissedSpaceTabExplanation;
	},
	[SET_DISMISSED_PLACEMENT_TAB_EXPLANATION](state, dismissedPlacementTabExplanation) {
		storage.setItem(DISMISSED_PLACEMENT_TAB_EXPLANATION, dismissedPlacementTabExplanation);
		state.dismissedPlacementTabExplanation = dismissedPlacementTabExplanation;
	},
	[SET_SEEN_INTERFACE_EXPLANATION](state, seenInterfaceExplanation) {
		storage.setItem(SEEN_INTERFACE_EXPLANATION, seenInterfaceExplanation);
		state.seenInterfaceExplanation = seenInterfaceExplanation;
	},
};

export default mutations;
